/**
 * Parses a rich text value from string or object format.
 * @param {string|object} richText - The rich text value to parse
 * @returns {object|null} - Parsed rich text object or null if invalid
 */
export const parseRichText = richText => {
  if (!richText) return null
  try {
    return typeof richText === "string" ? JSON.parse(richText) : richText
  } catch {
    return null
  }
}
